import { Component, Inject, OnInit } from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog'
import { ToastrService } from 'ngx-toastr'
import { AuthService } from '../../../auth.service'
import { MatInputModule } from '@angular/material/input'
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { CommonModule } from '@angular/common'
import { MatSelectModule } from '@angular/material/select'

@Component({
  selector: 'app-user-dialog',
  standalone: true,

  imports: [
    CommonModule,
    MatDialogTitle,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
      },
    },
  ],
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.css'],
})
export class UserDialogComponent implements OnInit {
  registerForm: FormGroup = new FormGroup({})
  isLoading: boolean = false
  roles: string[] = []
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    private authService: AuthService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.authService.getAllRoles().subscribe({
      next: (data) => {
        this.roles = data
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
    this.initializeForm()
  }

  initializeForm() {
    this.registerForm = this.fb.group({
      username: [this.data?.username || '', []],
      emailId: [this.data?.emailId || '', []],
      password: [this.data?.password, [Validators.required]],
      mobileNo: [this.data?.mobileNo, Validators.required],
      role: [this.data?.role || '', []],
    })
  }

  register(): void {
    if (this.registerForm.invalid) {
      return
    }

    this.isLoading = true
    const dateTimeNow = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000,
    ).toISOString()
    if (this.data !== null) {
      // Attach the user ID to the form data before making the updateUser call
      const updatedUser = {
        ...this.data,
        ...this.registerForm.value,
      }
      updatedUser.modifiedOn = dateTimeNow
      this.authService.updateUser(updatedUser).subscribe({
        next: (response: any) => {
          this.toastr.success('User updated successfully!', 'Success')
          this.dialogRef.close(this.registerForm.value)
          this.isLoading = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error('Failed to update user. Please try again.', 'Error')
        },
      })
    } else {
      const formData = {
        ...this.registerForm.value,
      }
      formData.addedOn = dateTimeNow
      formData.modifiedOn = dateTimeNow
      this.authService.register(formData).subscribe({
        next: (response: any) => {
          this.toastr.success('User registered successfully!', 'Success')
          this.dialogRef.close(this.registerForm.value)
          this.isLoading = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(
            'Failed to register user. Please try again.',
            'Error',
          )
        },
      })
    }
  }

  onCancel(): void {
    this.dialogRef.close(null)
  }
}
